<template>
  <div id="questionsPage">
    <div
      class="pageHeader"
      :style="{
        backgroundImage: 'url(' + require('@/assets/bg/top-bg-topic.jpg') + ')',
      }"
    >
      <div class="container" v-if="this.$store.state.user.user">
        <router-link :to="`/topics/${this.$store.state.user.user.id}`">
          <img
            class="pageHeaderLogo"
            src="@/assets/logo/next-era-white.png"
            alt="VIR Logo"
          />
        </router-link>

        <div class="subPageController">
          <router-link :to="`/topics/${this.$route.params.userId}`" class="pageLink">
            <font-awesome-icon class="backIcon" icon="long-arrow-alt-left" />
            Home
          </router-link>
          <font-awesome-icon icon="circle" class="desktop"/>
          <span class="blue desktop" v-if="topicTitle">{{ topicTitle }}</span>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="pageContentTitle" v-if="topicTitle">{{ topicTitle }}</div>
      <div class="pageContentDescription">
        <p v-if="topicDescription">
          {{topicDescription}}
        </p>
      </div>

      <div id="questionListWrapper" v-if="questions">
        <div
          class="questionListRow"
          v-for="question in questions"
          :key="question.id"
        >
        <router-link
              :to="`/topics/${$route.params.userId}/questions/${$route.params.topicId}/answer/${question.id}`"
            >
            <div class="left">
              <div class="questionAnswerRadio">
                <span class="questionAnswerRadioCheckmark" v-if="question.answer"
                  ><font-awesome-icon icon="check"
                /></span>
              </div>
              <div class="questionInfo">
                <div class="questionTitle">{{ question.title }}</div>
                <div
                  class="questionStatus"
                  :class="{ answered: question.answer }"
                >
                  <template v-if="question.answer">Answered!</template>
                  <template v-else>Not Answered</template>
                </div>
              </div>
            </div>
            <div class="right">            
              <svg width="35" height="19" viewBox="0 0 35 19" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 0h34.808v18.653H0z"/></defs><g transform="matrix(-1 0 0 1 35 0)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M.007 9.46a1.715 1.715 0 00.025.166l.037.135a.99.99 0 00.013.039l.04.103.026.05a1.196 1.196 0 00.122.2l.026.038c.018.023.036.045.055.066l7.976 7.981c.266.268.621.415.999.415a1.4 1.4 0 00.996-.413 1.4 1.4 0 00.415-1c0-.224-.052-.44-.15-.634v-.1l-5.769-5.769h28.579c.778 0 1.411-.633 1.411-1.411s-.633-1.411-1.411-1.411H4.818l5.503-5.505c.268-.266.416-.62.416-.997 0-.378-.146-.733-.414-1A1.407 1.407 0 009.326 0c-.362 0-.723.138-.998.413L.412 8.328l-.039.042-.015.017c-.025.029-.05.059-.073.09l-.008.01a1.052 1.052 0 00-.08.121 1.107 1.107 0 00-.085.166l-.038.103-.011.035-.031.114a1.156 1.156 0 00-.025.165 1.231 1.231 0 000 .27" fill="#009AD6" mask="url(#b)"/></g></svg>
            </div>
          </router-link>
        </div>
      </div>
      <div class="backWrapper">
        <router-link :to="`/topics/${this.$store.state.user.user.id}`">
          Back
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      topicTitle: null,
      topicDescription: null,
     questions: null
    };
  },
  methods: {
    getTopicInfo(response){
        this.topicTitle = response.data[0].topic;
        this.topicDescription = response.data[0].description;
    },
    getQuestions(response){
        this.questions = response.data;
    },
    init() {
      try {
        axios.get(`user/getTopicTitleByTopicId/${this.$route.params.topicId}`).then(this.getTopicInfo);        
        axios.get(`user/getQuestionsByTopic/${this.$route.params.topicId}/${this.$route.params.userId}`).then(this.getQuestions);
      } catch (e) {
        window.console.log(e);
      }
    }
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.pageContentTitle {
  font-family: Effra-Light;
  font-size: 56px;
  color: #009ad6;
  letter-spacing: 0;
  line-height: 54px;
  margin-top: 68px;
}
.pageContentDescription {
  font-family: Effra-Regular;
  font-size: 16px;
  color: #5f5f5f;
  letter-spacing: 0;
  line-height: 21px;
  margin-top: 30px;
  p {
    margin-bottom: 20px;
  }
  a {
    color: #009ad6;
  }
}
#questionListWrapper {
  margin-top: 40px;
  .questionListRow {
    transition: transform 0.25s ease-in-out;
    a {
      text-decoration: none;
      display: flex;
      align-items: center;
      background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
      box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
      border-radius: 8px;
      margin-bottom: 15px;
      padding: 17px 30px;
      justify-content: space-between;
      position: relative;      
      @media (max-width: $lg) {
        flex-direction: column-reverse;
        align-items: flex-start;
        width: 100%;
        padding: 17px;
      }
    }
    &:hover {
      transform: translateX(10px);
    }
    &:last-child {
      margin-bottom: 0px;
    }
    .left {
      display: flex;
      align-items: center;
      padding-right: 30px;
      @media (max-width: $lg) {
        flex-direction: column-reverse;
        align-items: flex-start;
        width: 100%;
        padding-right: 0;
      }
      .questionAnswerRadio {
        background-color: #eeeeee;
        box-shadow: inset 0 1px 4px 0 rgba(0, 0, 0, 0.09);
        border-radius: 13px;
        height: 26px;
        width: 26px;
        min-height: 26px;
        min-width: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;

        @media (max-width: $lg) {
          margin-top: 10px;
        }
        .questionAnswerRadioCheckmark {
          background-color: #84bf25;
          width: 16px;
          height: 16px;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            font-size: 10px;
            color: #ffffff;
          }
        }
      }
      .questionInfo {
        .questionTitle {          
          font-family: 'Effra-Regular';
          font-size: 16px;
          color: #000;
          letter-spacing: 0;
          line-height: 21px;
        }
        .questionStatus {
          font-family: Effra-Medium;
          font-size: 14px;
          color: #009ad6;
          letter-spacing: 0;
          line-height: 23px;
          margin-top: 5px;

          &.answered {
            font-family: Effra-Medium;
            font-size: 14px;
            color: #84bf25;
            letter-spacing: 0;
            line-height: 23px;
          }
        }
      }
    }
    .right {
      @media (max-width: $lg) {
        position: absolute;
        bottom: 25px;
        right: 15px;
      }
      svg{
        font-size: 30px;
      }
    }
  }
}
.backWrapper{
  margin-bottom: 120px;
  margin-top: 60px;
  text-align: center;
  a{
    font-family: Effra-Heavy;
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    background: #009ad6;
    border-radius: 5px;
    border: 0px;
    text-transform: uppercase;
    padding: 10px 40px;
    margin-left: 5px;
    margin-right: 5px;
    text-decoration: none;
  }
  
}
.subPageController {
  display: inline-flex;
  align-items: center;
  padding: 7px 15px;
  font-family: Effra-Medium;
  font-size: 13px;
  color: #5f5f5f;
  letter-spacing: 0;
  line-height: 23px;
  background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
  box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
  border-radius: 4px;
  position: absolute;
  bottom: -60px;
  left: 0;
  .pageLink {
    display: flex;
    align-items: center;
  }
  a {
    color: #5f5f5f;
    text-decoration: none;
  }
  .blue {
    color: #009cdc;
  }
  svg {
    font-size: 4px;
    margin-left: 15px;
    margin-right: 15px;
    &.backIcon {
      font-size: 16px;
      margin-left: 0px;
      margin-right: 20px;
    }
  }
}
</style>